<script>
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const host = urlParams.get("shop");

    window.location.href = "https://" + host + "/admin/apps/expertify-tasks";
</script>

<h1>Loading...</h1>
